var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-modal__section"},[_c('div',{staticClass:"settings-modal__section-title"},[_vm._v("\n    "+_vm._s(_vm.$t('settings.localization.title'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }